import {Component, OnInit} from '@angular/core';
import {TimeAppSuppliesService} from '../services/time-app-supplies.service';
import {Observable} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageBoxService} from '../../../services/message-box.service';
import {SupplyEntry} from '../../../models/swiss-service.models';
import {faBolt, faFileExport} from '@fortawesome/free-solid-svg-icons';
import {DataService} from '../../services/data.service';

@Component({
    selector: 'app-time-app-work-supply-list',
    templateUrl: './time-app-work-supply-list.component.html',
    styleUrl: './time-app-work-supply-list.component.scss'
})
export class TimeAppWorkSupplyListComponent implements OnInit {
    protected supplies: Observable<SupplyEntry[]>;
    protected readonly faBolt = faBolt;
    protected readonly faFileExport = faFileExport;

    constructor(private supplyService: TimeAppSuppliesService, private router: Router, private route: ActivatedRoute, private msgService: MessageBoxService, private dataService: DataService) {
        this.supplies = supplyService.getObjectSupplies$();
    }

    ngOnInit() {
    }

    protected async navigateToAddSupplyEntry() {
        if (await this.dataService.isDayClosed(this.dataService.getChosenDateFormatted())) {
            this.msgService.showErrorByLanguageKey('MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.alreadySynced.text', 'MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.alreadySynced.title');
            return;
        }
        this.router.navigate(['../supply-entry', ''], {relativeTo: this.route});
    }

    protected async navigateToEdit(supplyEntryID: string) {
        if ((await this.supplyService.getSupplyEntry(supplyEntryID))?.exported) {
            this.msgService.showErrorByLanguageKey('MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.alreadySynced.text', 'MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.alreadySynced.title');
            return;
        }
        await this.router.navigate(['../supply-entry', supplyEntryID], {relativeTo: this.route});
    }

    protected async deleteSupplyEntry(supplyEntryID: string) {
        if ((await this.supplyService.getSupplyEntry(supplyEntryID))?.exported) {
            this.msgService.showErrorByLanguageKey('MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.alreadySynced.text', 'MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.alreadySynced.title');
            return;
        }
        try {
            await this.supplyService.deleteEntry(supplyEntryID);
            this.msgService.showSuccessByLanguageKey('MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.deleteEntry.text', 'MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.deleteEntry.title');
        } catch (error) {
            this.msgService.showErrorByLanguageKey('MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.deleteEntryError.text', 'MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.MESSAGES.deleteEntryError.title');
        }
    }
}
